import { ClerkProvider } from "@clerk/clerk-react";
import { AuthProvider } from "@/lib/auth";
import { config } from "@/config/env";
import type { ReactNode } from "react";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ClerkProvider 
      publishableKey={config.clerkPublishableKey} 
      afterSignOutUrl="/sign-in"
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
    >
      <AuthProvider>{children}</AuthProvider>
    </ClerkProvider>
  );
}
